const POPUP_OPEN_AUTO_RELEASE_MS = 2_000;

let popupOpenInFlight = false;
let popupOpenAutoReleaseTimer: ReturnType<typeof setTimeout> | null = null;

export function tryClaimPopupOpen(): boolean {
  if (popupOpenInFlight) return false;
  popupOpenInFlight = true;
  if (popupOpenAutoReleaseTimer !== null) {
    clearTimeout(popupOpenAutoReleaseTimer);
  }
  popupOpenAutoReleaseTimer = setTimeout(() => {
    popupOpenInFlight = false;
    popupOpenAutoReleaseTimer = null;
  }, POPUP_OPEN_AUTO_RELEASE_MS);
  return true;
}

export function releasePopupOpen(): void {
  popupOpenInFlight = false;
  if (popupOpenAutoReleaseTimer !== null) {
    clearTimeout(popupOpenAutoReleaseTimer);
    popupOpenAutoReleaseTimer = null;
  }
}
